import { Question } from "@zp-models/question";

export const WIZARD_STEPS: Record<string, Question> = {
  step1: {
    id: "step1",
    title: "WIZARD_STEPS.STEP1.TITLE",
    titleForReceipt: "",
    subTitle: "WIZARD_STEPS.STEP1.SUBTITLE",
    type: "form",
    fields: [
      {
        name: "organisation_name",
        type: "input",
        label: "WIZARD_STEPS.STEP1.FIELDS.ORGANISATION_NAME.LABEL",
        required: false,
      },
      {
        name: "number_of_employees",
        type: "input",
        label: "WIZARD_STEPS.STEP1.FIELDS.NUMBER_OF_EMPLOYEES.LABEL",
        subLabel: "WIZARD_STEPS.STEP1.FIELDS.NUMBER_OF_EMPLOYEES.SUB_LABEL",
        required: true,
      },
    ],
    button: {
      label: "WIZARD_STEPS.STEP1.BUTTON.LABEL",
      variant: "WIZARD_STEPS.STEP1.BUTTON.VARIANT",
    },
  },
  step2: {
    id: "step2",
    title: "WIZARD_STEPS.STEP2.TITLE",
    subTitle: "WIZARD_STEPS.STEP2.SUBTITLE",
    titleForReceipt: "WIZARD_STEPS.STEP2.TITLE_FOR_RECEIPT",
    type: "form",
    fields: [
      {
        name: "mobility_options",
        type: "checkbox",
        options: [
          {
            value: "ov",
            label: "WIZARD_STEPS.STEP2.FIELDS.OPTIONS.COMMUTE_PUBLIC_TRANSPORT.LABEL",
            receiptLabel:
              "WIZARD_STEPS.STEP2.FIELDS.OPTIONS.COMMUTE_PUBLIC_TRANSPORT.RECEIPT_LABEL",
            advicePointer: "Start",
          },
          {
            value: "deelvervoer",
            label: "WIZARD_STEPS.STEP2.FIELDS.OPTIONS.COMMUTE_SHARED_TRANSPORT.LABEL",
            receiptLabel:
              "WIZARD_STEPS.STEP2.FIELDS.OPTIONS.COMMUTE_SHARED_TRANSPORT.RECEIPT_LABEL",
            advicePointer: "Start",
          },
          {
            value: "Privéreizen",
            label: "WIZARD_STEPS.STEP2.FIELDS.OPTIONS.PRIVATE_TRAVEL_REIMBURSEMENT.LABEL",
            receiptLabel:
              "WIZARD_STEPS.STEP2.FIELDS.OPTIONS.PRIVATE_TRAVEL_REIMBURSEMENT.RECEIPT_LABEL",
            advicePointer: "Plus",
          },
          {
            value: "Kilometerregistratie",
            label: "WIZARD_STEPS.STEP2.FIELDS.OPTIONS.PERSONAL_CAR_MILEAGE.LABEL",
            receiptLabel: "WIZARD_STEPS.STEP2.FIELDS.OPTIONS.PERSONAL_CAR_MILEAGE.RECEIPT_LABEL",
            advicePointer: "Plus",
          },
          {
            value: "thuiswerkregistratie",
            label: "WIZARD_STEPS.STEP2.FIELDS.OPTIONS.REMOTE_WORK_DAYS.LABEL",
            receiptLabel: "WIZARD_STEPS.STEP2.FIELDS.OPTIONS.REMOTE_WORK_DAYS.RECEIPT_LABEL",
            advicePointer: "Plus",
          },
          {
            value: "verrekenen_kosten",
            label: "WIZARD_STEPS.STEP2.FIELDS.OPTIONS.OFFSET_EXPENSES.LABEL",
            receiptLabel: "WIZARD_STEPS.STEP2.FIELDS.OPTIONS.OFFSET_EXPENSES.RECEIPT_LABEL",
            advicePointer: "Pro",
          },
          {
            value: "fietsenplan",
            label: "WIZARD_STEPS.STEP2.FIELDS.OPTIONS.BIKE_PLAN_OFFER.LABEL",
            receiptLabel: "WIZARD_STEPS.STEP2.FIELDS.OPTIONS.BIKE_PLAN_OFFER.RECEIPT_LABEL",
            advicePointer: "Pro",
          },
          {
            value: "mobiliteitshubs",
            label: "WIZARD_STEPS.STEP2.FIELDS.OPTIONS.MOBILITY_HUBS_OFFER.LABEL",
            receiptLabel: "WIZARD_STEPS.STEP2.FIELDS.OPTIONS.MOBILITY_HUBS_OFFER.RECEIPT_LABEL",
            advicePointer: "Pro",
          },
          {
            value: "mobiliteitsdeclaraties",
            label: "WIZARD_STEPS.STEP2.FIELDS.OPTIONS.OTHER_MOBILITY_CLAIMS.LABEL",
            receiptLabel: "WIZARD_STEPS.STEP2.FIELDS.OPTIONS.OTHER_MOBILITY_CLAIMS.RECEIPT_LABEL",
            advicePointer: "Pro",
          },
        ],
      },
    ],
    button: {
      label: "WIZARD_STEPS.STEP2.BUTTON.LABEL",
      variant: "WIZARD_STEPS.STEP2.BUTTON.VARIANT",
    },
  },
  step3: {
    id: "step3",
    title: "WIZARD_STEPS.STEP3.TITLE",
    subTitle: "WIZARD_STEPS.STEP3.SUBTITLE",
    titleForReceipt: "WIZARD_STEPS.STEP3.TITLE_FOR_RECEIPT",
    type: "radio",
    fields: [
      {
        name: "mobility_policy",
        type: "radio",
        options: [
          {
            value: "yes",
            label: "WIZARD_STEPS.STEP3.FIELDS.OPTIONS.YES.LABEL",
            receiptLabel: "WIZARD_STEPS.STEP3.FIELDS.OPTIONS.YES.RECEIPT_LABEL",
          },
          {
            value: "yes_but_want_to_improve",
            label: "WIZARD_STEPS.STEP3.FIELDS.OPTIONS.YES_BUT_WANT_TO_IMPROVE.LABEL",
            receiptLabel: "WIZARD_STEPS.STEP3.FIELDS.OPTIONS.YES_BUT_WANT_TO_IMPROVE.RECEIPT_LABEL",
          },
          {
            value: "no_but_interested",
            label: "WIZARD_STEPS.STEP3.FIELDS.OPTIONS.NO_BUT_INTERESTED.LABEL",
            receiptLabel: "WIZARD_STEPS.STEP3.FIELDS.OPTIONS.NO_BUT_INTERESTED.RECEIPT_LABEL",
          },
          {
            value: "no",
            label: "WIZARD_STEPS.STEP3.FIELDS.OPTIONS.NO.LABEL",
            receiptLabel: "WIZARD_STEPS.STEP3.FIELDS.OPTIONS.NO.RECEIPT_LABEL",
          },
        ],
      },
    ],
    button: {
      label: "WIZARD_STEPS.STEP3.BUTTON.LABEL",
      variant: "WIZARD_STEPS.STEP3.BUTTON.VARIANT",
    },
  },
  step4: {
    id: "step4",
    title: "WIZARD_STEPS.STEP4.TITLE",
    subTitle: "WIZARD_STEPS.STEP4.SUBTITLE",
    titleForReceipt: "WIZARD_STEPS.STEP4.TITLE_FOR_RECEIPT",
    type: "form",
    fields: [
      {
        name: "automated_controles",
        type: "radio",
        options: [
          {
            value: "yes_all",
            label: "WIZARD_STEPS.STEP4.FIELDS.OPTIONS.YES_ALL.LABEL",
            receiptLabel: "WIZARD_STEPS.STEP4.FIELDS.OPTIONS.YES_ALL.RECEIPT_LABEL",
            advicePointer: "Pro",
          },
          {
            value: "yes_some",
            label: "WIZARD_STEPS.STEP4.FIELDS.OPTIONS.YES_SOME.LABEL",
            receiptLabel: "WIZARD_STEPS.STEP4.FIELDS.OPTIONS.YES_SOME.RECEIPT_LABEL",
            advicePointer: "Plus",
          },
          {
            value: "no",
            label: "WIZARD_STEPS.STEP4.FIELDS.OPTIONS.NO.LABEL",
            receiptLabel: "WIZARD_STEPS.STEP4.FIELDS.OPTIONS.NO.RECEIPT_LABEL",
            advicePointer: "Start",
          },
        ],
      },
    ],
    button: {
      label: "WIZARD_STEPS.STEP4.BUTTON.LABEL",
      variant: "WIZARD_STEPS.STEP4.BUTTON.VARIANT",
    },
  },
  step5: {
    id: "step5",
    title: "WIZARD_STEPS.STEP5.TITLE",
    subTitle: "WIZARD_STEPS.STEP5.SUBTITLE",
    titleForReceipt: "WIZARD_STEPS.STEP5.TITLE_FOR_RECEIPT",
    type: "form",
    fields: [
      {
        name: "integration",
        type: "radio",
        options: [
          {
            value: "yes",
            label: "WIZARD_STEPS.STEP5.FIELDS.OPTIONS.YES.LABEL",
            receiptLabel: "WIZARD_STEPS.STEP5.FIELDS.OPTIONS.YES.RECEIPT_LABEL",
            advicePointer: "Pro",
          },
          {
            value: "no_self_loading",
            label: "WIZARD_STEPS.STEP5.FIELDS.OPTIONS.NO_SELF_LOADING.LABEL",
            receiptLabel: "WIZARD_STEPS.STEP5.FIELDS.OPTIONS.NO_SELF_LOADING.RECEIPT_LABEL",
            advicePointer: "Plus",
          },
          {
            value: "no",
            label: "WIZARD_STEPS.STEP5.FIELDS.OPTIONS.NO.LABEL",
            receiptLabel: "WIZARD_STEPS.STEP5.FIELDS.OPTIONS.NO.RECEIPT_LABEL",
            advicePointer: "Start",
          },
        ],
      },
    ],
    button: {
      label: "WIZARD_STEPS.STEP5.BUTTON.LABEL",
      variant: "WIZARD_STEPS.STEP5.BUTTON.VARIANT",
    },
  },
  step6: {
    id: "step6",
    title: "WIZARD_STEPS.STEP6.TITLE",
    subTitle: "WIZARD_STEPS.STEP6.SUBTITLE",
    titleForReceipt: "WIZARD_STEPS.STEP6.TITLE_FOR_RECEIPT",
    type: "form",
    fields: [
      {
        name: "sso",
        type: "radio",
        options: [
          {
            value: "required",
            label: "WIZARD_STEPS.STEP6.FIELDS.OPTIONS.REQUIRED.LABEL",
            receiptLabel: "WIZARD_STEPS.STEP6.FIELDS.OPTIONS.REQUIRED.RECEIPT_LABEL",
            advicePointer: "Pro",
          },
          {
            value: "optional",
            label: "WIZARD_STEPS.STEP6.FIELDS.OPTIONS.OPTIONAL.LABEL",
            receiptLabel: "WIZARD_STEPS.STEP6.FIELDS.OPTIONS.OPTIONAL.RECEIPT_LABEL",
            advicePointer: "Plus",
          },
          {
            value: "not_used",
            label: "WIZARD_STEPS.STEP6.FIELDS.OPTIONS.NOT_USED.LABEL",
            receiptLabel: "WIZARD_STEPS.STEP6.FIELDS.OPTIONS.NOT_USED.RECEIPT_LABEL",
            advicePointer: "Start",
          },
        ],
      },
    ],
    button: {
      label: "WIZARD_STEPS.STEP6.BUTTON.LABEL",
      variant: "WIZARD_STEPS.STEP6.BUTTON.VARIANT",
    },
  },
  step7: {
    id: "step7",
    title: "WIZARD_STEPS.STEP7.TITLE",
    subTitle: "WIZARD_STEPS.STEP7.SUBTITLE",
    titleForReceipt: "WIZARD_STEPS.STEP7.TITLE_FOR_RECEIPT",
    type: "form",
    fields: [
      {
        name: "budget_based",
        type: "radio",
        options: [
          {
            value: "yes",
            label: "WIZARD_STEPS.STEP7.FIELDS.OPTIONS.YES.LABEL",
            receiptLabel: "WIZARD_STEPS.STEP7.FIELDS.OPTIONS.YES.RECEIPT_LABEL",
            advicePointer: "Pro",
          },
          {
            value: "no",
            label: "WIZARD_STEPS.STEP7.FIELDS.OPTIONS.NO.LABEL",
            receiptLabel: "WIZARD_STEPS.STEP7.FIELDS.OPTIONS.NO.RECEIPT_LABEL",
            advicePointer: "Plus",
          },
        ],
      },
    ],
    button: {
      label: "WIZARD_STEPS.STEP7.BUTTON.LABEL",
      variant: "WIZARD_STEPS.STEP7.BUTTON.VARIANT",
    },
  },
};
